export default function Component() {
  return <h2 className="text-2xl font-light text-lime-400">Multitec</h2>
}
